module.exports = "/packs/003-6bd956fdbd8e6bef7308b43d36c862d1.jpg";